import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'currentyFormat' })
export class CurrentyFormatPipe implements PipeTransform {
  transform(value: number): string {
    // return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return value?.toString().replace(/^[0-9]\d{2}/g, ',');
  }
}
